import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import SvgIcon from '../../common/svgicon/svgicon.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import Anchor from '../../../common/common/anchor/index.js'

const AttachmentFile = ({ href, name, onDelete }) => (
  <Wrap>
    <SvgIcon name='tasks' size='20' />
    <StyledAnchor
      className='info'
      href={href}
      target='_blank'
      rel='noopener noreferrer'
    >
      {name}
    </StyledAnchor>
    {onDelete && (
      <IconButton
        icon='x'
        type='secondary'
        onClick={onDelete}
        canHover
        className='action'
      />
    )}
  </Wrap>
)

const Wrap = styled.div`
  min-height: 32px;
  display: flex;
  background-color: #eceff1;
  padding: 0 8px;

  > .csvgicon {
    fill: #78909c;
    margin: auto;
  }

  .cicon-button > .content {
    background: #ced7db;
  }

  > .action {
    margin: auto;
  }

  &:nth-child(2n) {
    background: #dce2e5;
  }

  &:last-child {
    border: none;
    margin-bottom: 8px;
  }
`

const StyledAnchor = styled(Anchor)`
  align-self: center;
  color: #78909c;
  font-size: 12px;
  flex: 1;
  line-height: 14px;
  margin-left: 14px;
  padding: 4px 0;
  text-transform: capitalize;
  text-decoration: none;
`

AttachmentFile.propTypes = {
  href: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onDelete: PropTypes.func
}

export default AttachmentFile
